import Layout from '@/views/layout/Layout'

const cmsUniversityInfoRoutes = {
  path: '/cms/banner',
  component: Layout,
  redirect: '/cms/banner/list',
  name: 'cms.banner',
  meta: { title: '轮播图管理', icon: 'cms' },
  children: [
    {
      path: 'list',
      name: 'cms.banner.list',
      component: () => import('@/views/cms/banner/list'),
      meta: { title: '轮播图列表', icon: 'ums-admin' }
    },
    {
      path: 'create',
      name: 'cms.banner.create',
      component: () => import('@/views/cms/banner/create'),
      meta: { title: '添加轮播图', icon: 'ums-admin' }
    },
    {
      path: ':id/edit',
      name: 'cms.banner.edit',
      hidden: true,
      component: () => import('@/views/cms/banner/edit'),
      meta: { title: '编辑轮播图', icon: 'ums-admin' }
    }
  ]
}

export default cmsUniversityInfoRoutes



// WEBPACK FOOTER //
// ./src/router/module/cmsBannerRoute.js